import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Button,
} from "@mui/material";

export default function DeleteScoreableDialog({
  open,
  onClose,
  onConfirm,
  selectedScoreable,
  cardCount,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Confirm Delisting</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Remove/Delist {selectedScoreable?.displayName || "scoreable"} from
          marketplace?
          {cardCount > -1 && (
            <Typography
              component="p"
              variant="body2"
              sx={{ mt: 2, fontWeight: "bold" }}
            >
              {cardCount} card{cardCount !== 1 ? "s" : ""} in the marketplace
              (includes expired cards)
            </Typography>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>No</Button>
        <Button onClick={onConfirm} autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
